<template>
    <div class="product_information product_information_main_box_custom">
        <div class="accordian_detals contact_detail_wrap account_detail_left_rt">
            <div class="acc">
                <div class="acc__card">
                    <div class="acc__title acc_head d-none">&nbsp;</div>
                    <div class="acc__panel order-list-page">
                        <div
                            v-for="(address, aIndex) in addresses"
                            :key="address.id"
                            class="mb-1"
                        >
                            <div
                                class="address-header d-flex justify-content-between align-items-center"
                                @click="toggleAddress(address)"
                            >
                                <div class="address-header-title text-truncate">
                                    <strong>Address {{ aIndex + 1 }}:</strong>
                                    {{ address.company_name }},
                                    {{ address.address_line1 }}
                                    <span v-if="address.address_line2">
                                        , {{ address.address_line2 }}
                                    </span>,
                                    {{ address.city }}, {{ address.state }}
                                    {{ address.zip }}
                                    <span v-if="address.phone">, {{ address.phone }}</span>
                                    <span v-if="address.email">, {{ address.email }}</span>
                                </div>
                                <div class="address-header-arrow">
                                    <span
                                        class="arrow-icon"
                                        :class="{ open: isAddressOpen(address) }"
                                    ></span>
                                </div>
                            </div>

                            <div
                                v-if="
                                    isAddressOpen(address) &&
                                        groupedByAddress[address.id] &&
                                        groupedByAddress[address.id].length
                                "
                                class="address-items-wrapper"
                            >
                                <div
                                    class="row base_pro_row_custom m-0"
                                    v-for="(group, groupIndex) in groupedByAddress[address.id]"
                                    :key="
                                        address.id +
                                            '-' +
                                            groupIndex +
                                            '-' +
                                            (group.item.id || group.item.unique_item_id)
                                    "
                                >
                                    <!-- col-md-12: full-width item row (matches admin structure) -->
                                    <div class="col-md-12 order-list-col">
                                        <div class="p_border pl-0">
                                            <div class="d-flex base_product_box_custom product_details_box">
                                                <!-- LEFT group: image + product text -->
                                                <div class="d-flex">
                                                    <div class="align-self-start">
                                                        <div class="product-box">
                                                            <img
                                                                v-if="group.item.design_image"
                                                                :src="group.item.design_image ? group.item.design_image.split(',')[0] : group.item.design_image"
                                                                class="img-fluid"
                                                            />
                                                            <img
                                                                v-else-if="group.item.product_image"
                                                                :src="group.item.product_image.url"
                                                                class="img-fluid"
                                                            />
                                                            <a
                                                                href="javascript:void(0)"
                                                                class="hover_search"
                                                                data-toggle="modal"
                                                                :data-target="'#imagepreview-byaddr-' + address.id + '-' + groupIndex"
                                                            >
                                                                <img src="/maincss/images/zoom.svg" alt="Zoom" />
                                                            </a>
                                                        </div>
                                                        <span class="product_number">{{ group.item.product_number }}</span>
                                                    </div>

                                                    <div class="align-self-start base_product_text_box_custom">
                                                        <div class="color-black font-weight-bold pb_10 sub_pro_head_custom">
                                                            {{ group.item.name }}
                                                        </div>
                                                        <div class="color-line" v-if="group.item.Vendor && group.item.Vendor.name">
                                                            <span class="color-black font-weight-bold">Vendor:</span>
                                                            {{ group.item.Vendor.name }}
                                                        </div>
                                                        <div class="product_details">
                                                            <div class="color-line mt_12 d-flex align-items-center">
                                                                <span>{{ group.sizes.map(s => `${s.sizeLabel}:${s.qty}`).join(', ') }}</span>
                                                                <span class="ml-2">| Total Qty : <span class="font-weight-bold">{{ group.totalQty }}</span></span>
                                                            </div>
                                                            <div class="color-line mt_8 d-flex align-items-center">
                                                                <img
                                                                    v-if="group.item.color && group.item.color.swatches"
                                                                    class="color_swatch_byaddr"
                                                                    :src="group.item.color.swatches"
                                                                    v-tooltip="{ content: group.item.color.name, autoHide: false }"
                                                                    alt=""
                                                                />
                                                                <span
                                                                    v-else-if="group.item.color"
                                                                    :title="group.item.color.name"
                                                                    class="color_swatch_byaddr"
                                                                    :style="'background: ' + group.item.color.hex + ';'"
                                                                ></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- RIGHT: decorator logo + service (inside product_details_box as 2nd flex child) -->
                                                <div class="d-flex justify-content-center align-items-center pr-2">
                                                    <div class="brand-logo-wrapper text-center">
                                                        <div v-if="getDecoratorLogo(group.item)" class="mb-1">
                                                            <img :src="getDecoratorLogo(group.item)" alt="Brand logo" class="brand-logo-img" />
                                                        </div>
                                                        <div class="decoration-service-name mt-1">{{ getDecorationServiceName(group.item) }}</div>
                                                        <div v-if="getEstimatedShippingDate(group.item)" class="decoration-shipdate mt-0">
                                                            Est. Ship Date: {{ formatEstimatedShippingDate(getEstimatedShippingDate(group.item)) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Name/Number table (below product row, above imprint locations) -->
                                            <NameNumberTable
                                                :rows="getSplitNameNumberTable(address.id, group)"
                                                :show-export="true"
                                                csv-file-name="NameAndNumberByAddress.csv"
                                                :csv-header="'Name,Number,Size\\n'"
                                            />

                                            <!-- Imprint locations F/B/L/R row -->
                                            <div class="p_border decoration_main_box imprint-locations-wrapper">
                                                <ImprintLocationsRow
                                                    :locations="getImprintLocations(group.item)"
                                                    :modal-target="'#canvas-images-model-byaddr-' + address.id + '-' + groupIndex"
                                                    @open-modal="onImprintOpenCanvasModal(address.id, groupIndex, $event)"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Old artwork col (hidden via CSS) -->
                                    <div class="col-md-4 order-list-col-sec">
                                        <div class="artwork-old-block">
                                            <div class="p_border decoration_main_box">
                                                <div class="d-flex">
                                                    <div class="align-self-start">
                                                        <div v-if="artworkImageUrl(group.item)" class="product-box mb_10">
                                                            <img
                                                                v-if="getDecoration(group.item).art_work"
                                                                :src="getDecoration(group.item).art_work"
                                                                class="img-fluid"
                                                            />
                                                            <img
                                                                v-else-if="group.item.front_art_url"
                                                                :src="group.item.front_art_url"
                                                                class="img-fluid"
                                                            />
                                                            <p class="hover_searc_p_custom">
                                                                <a
                                                                    href="#"
                                                                    class="hover_search"
                                                                    data-toggle="modal"
                                                                    :data-target="
                                                                        '#artworkpreview-byaddr-' +
                                                                            address.id +
                                                                            '-' +
                                                                            groupIndex
                                                                    "
                                                                >
                                                                    <img
                                                                        class="search_hover_img_tag"
                                                                        src="/maincss/images/zoom.svg"
                                                                        alt=" "
                                                                    />
                                                                </a>
                                                            </p>
                                                        </div>
                                                        <div class="product_details">
                                                            <div class="color-line">
                                                                <div>
                                                                    Decoration Service:
                                                                    {{ getDecorationServiceName(group.item) }}
                                                                </div>
                                                                <div
                                                                    v-if="
                                                                        group.estimatedShippingDate ||
                                                                            getEstimatedShippingDate(group.item)
                                                                    "
                                                                    style="font-size: 14px; color: #666; margin-top: 4px;"
                                                                >
                                                                    Est. Ship Date:
                                                                    {{
                                                                        formatEstimatedShippingDate(
                                                                            group.estimatedShippingDate ||
                                                                                getEstimatedShippingDate(group.item)
                                                                        )
                                                                    }}
                                                                </div>
                                                                <ul
                                                                    v-if="
                                                                        group.item.decoration_colors &&
                                                                            group.item.decoration_colors.length > 0
                                                                    "
                                                                    class="standard_colors"
                                                                >
                                                                    <span class="mr-1 font_size_14">
                                                                        Decoration Colors:
                                                                    </span>
                                                                    <li
                                                                        v-for="(color, cIdx) in group.item.decoration_colors"
                                                                        :key="cIdx"
                                                                        :style="
                                                                            'background-color:' +
                                                                                (color.hex || color) +
                                                                                ';'
                                                                        "
                                                                        v-tooltip="{
                                                                            content: color.name
                                                                                ? color.name + ' ' + (color.hex || '')
                                                                                : color.hex || color,
                                                                            autoHide: false
                                                                        }"
                                                                    ></li>
                                                                </ul>
                                                            </div>
                                                            <div class="mr-1 mt-2">
                                                                <a
                                                                    v-if="showDesignImages(group.item.design_images)"
                                                                    type="button"
                                                                    class="images-popup-btn btn btn_outline_primary buttons"
                                                                    :data-target="
                                                                        '#canvas-images-model-byaddr-' +
                                                                            address.id +
                                                                            '-' +
                                                                            groupIndex
                                                                    "
                                                                    data-toggle="modal"
                                                                >
                                                                    Images
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <ArtworkPreviewModal
                                        :modal-id="
                                            'canvas-images-model-byaddr-' +
                                                address.id +
                                                '-' +
                                                groupIndex
                                        "
                                        :design-images="
                                            getDesignImagesForCanvasModal(
                                                group.item,
                                                address.id + '-' + groupIndex
                                            )
                                        "
                                        :on-close="
                                            () =>
                                                onCloseCanvasModalByAddress(
                                                    address.id,
                                                    groupIndex
                                                )
                                        "
                                    />

                                    <div
                                        class="modal fade cart_preview"
                                        :id="
                                            'imagepreview-byaddr-' +
                                                address.id +
                                                '-' +
                                                groupIndex
                                        "
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered cart_modal_s"
                                            style="max-width: 823px; width: 100%;"
                                        >
                                            <div class="modal-content">
                                                <div class="modal-header border-bottom-0">
                                                    <div
                                                        class="order-number"
                                                        v-if="
                                                            orderDetail &&
                                                                orderDetail.unique_order_id
                                                        "
                                                    >
                                                        <h3>
                                                            Order Number-:
                                                            <span>
                                                                <b>#{{ orderDetail.unique_order_id }}</b>
                                                            </span>
                                                        </h3>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        class="close"
                                                        data-dismiss="modal"
                                                        aria-label="Close"
                                                    >
                                                        <img
                                                            src="/maincss/images/cancel.svg"
                                                            alt=" "
                                                        />
                                                    </button>
                                                </div>
                                                <div
                                                    v-if="
                                                        group.item.design_images &&
                                                            parseDesignImagesForPreview(
                                                                group.item.design_images
                                                            ).length > 0
                                                    "
                                                    class="modal-body pt-0"
                                                >
                                                    <div
                                                        class="canvas_auto_preview_images"
                                                        style="display:flex; margin-top: 20px;"
                                                    >
                                                        <div
                                                            class="mx-auto preview-image"
                                                            style="padding-left: 10px;"
                                                            v-for="(design_img, dIdx) in parseDesignImagesForPreview(group.item.design_images)"
                                                            :key="dIdx"
                                                        >
                                                            <h4>
                                                                {{
                                                                    (design_img.label || "").replace(
                                                                        /(?:^|\s|-)\S/g,
                                                                        (x) => x.toUpperCase()
                                                                    )
                                                                }}
                                                            </h4>
                                                            <div class="product-box text-center mt_10">
                                                                <img
                                                                    v-if="design_img && design_img.url"
                                                                    :src="design_img.url"
                                                                    :style="
                                                                        group.item.color &&
                                                                            group.item.color.hex
                                                                            ? 'background-color:' +
                                                                                  group.item.color.hex +
                                                                                  ';'
                                                                            : ''
                                                                    "
                                                                    class="img-fluid"
                                                                />
                                                                <img
                                                                    v-else-if="group.item.product_image"
                                                                    :src="group.item.product_image.url"
                                                                    class="img-fluid"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="modal-body pt-0">
                                                    <div
                                                        class="canvas_auto_preview_images new_canvas_images1"
                                                        style="display:flex; margin-top: 20px;"
                                                    >
                                                        <div
                                                            class="mx-auto preview-image"
                                                            style="padding-left: 10px;"
                                                        >
                                                            <div class="product-box">
                                                                <img
                                                                    v-if="group.item.design_image"
                                                                    :src="
                                                                        group.item.design_image
                                                                            ? group.item.design_image.split(',')[0]
                                                                            : group.item.design_image
                                                                    "
                                                                    class="img-fluid"
                                                                />
                                                                <img
                                                                    v-else-if="group.item.product_image"
                                                                    :src="group.item.product_image.url"
                                                                    class="img-fluid"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="modal fade cart_preview"
                                        :id="
                                            'artworkpreview-byaddr-' +
                                                address.id +
                                                '-' +
                                                groupIndex
                                        "
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered order_details_art_work_popup_custom"
                                        >
                                            <div class="modal-content">
                                                <div class="modal-header border-bottom-0 py-2 mb_30">
                                                    <button
                                                        type="button"
                                                        class="close p-0"
                                                        data-dismiss="modal"
                                                        aria-label="Close"
                                                    >
                                                        <img
                                                            src="/maincss/images/cancel.svg"
                                                            alt=""
                                                        />
                                                    </button>
                                                </div>
                                                <div class="modal-body pt-0">
                                                    <div class="mx-auto preview-image text-center mb_26">
                                                        <img
                                                            v-if="getDecoration(group.item).art_work"
                                                            :src="getDecoration(group.item).art_work"
                                                            alt=""
                                                        />
                                                        <img
                                                            v-else-if="group.item.front_art_url"
                                                            :src="group.item.front_art_url"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="costSummary" class="byaddress-total-section row mx-0 total_price mt-3">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                    <div class="row justify-content-end mx-0 cart-total">
                        <div class="col-md-7 total-sec-col byaddress-total-col pl-2 pr-4 pb-3">
                            <div class="border-right-0 base_product_total_box_custom_main_box byaddress-fee-summary">
                                <div class="product_details">
                                    <div class="row">
                                        <div class="col-md-12" v-if="costSummary.baseFeeTotal > 0">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row">
                                                <span class="total_p_custom byaddress-label">{{ costSummary.baseFeeLabel }}</span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.baseFeeTotal) }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="costSummary.runChargeTotal > 0">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row">
                                                <span class="total_p_custom byaddress-label">{{ costSummary.runChargeLabel }}</span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.runChargeTotal) }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="costSummary.setupDesignTotal > 0">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row">
                                                <span class="total_p_custom byaddress-label">{{ costSummary.setupDesignLabel }}</span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.setupDesignTotal) }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="costSummary.packingTotal > 0">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row">
                                                <span class="total_p_custom byaddress-label">
                                                    <div class="d-flex align-items-center">
                                                        <span class="text-nowrap">{{ costSummary.packingLabel }}</span>
                                                        <div class="tooltip-wrapper" v-if="costSummary.packingBreakdown && costSummary.packingBreakdown.length > 0" @click.stop="toggleOrderTooltip('packingKitting')">
                                                            <svg class="ml_6 info-icon-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                                            <div v-if="orderTooltipVisible === 'packingKitting'" class="tooltip-content is-visible">
                                                                <div class="tooltip-header">
                                                                    <h4>{{ costSummary.packingLabel }} Breakdown</h4>
                                                                    <svg class="close-icon" @click.stop="closeOrderTooltip" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                    </svg>
                                                                </div>
                                                                <div class="tooltip-body">
                                                                    <table class="base-fee-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Fee</th>
                                                                                <th>Qty</th>
                                                                                <th>Amt</th>
                                                                                <th>Total</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in costSummary.packingBreakdown" :key="index">
                                                                                <td>{{ item.name || item.service_name || 'Packaging, Kitting and Handling Service' }}</td>
                                                                                <td>{{ item.quantity || item.qty || '-' }}</td>
                                                                                <td>{{ item.amt || item.amount ? formatPrice(parseFloat(item.amt || item.amount || 0)) : '-' }}</td>
                                                                                <td>{{ formatPrice(parseFloat(item.total || item.amt || item.amount || 0)) }}</td>
                                                                            </tr>
                                                                            <tr v-if="costSummary.packingTotal > 0" class="total-row">
                                                                                <td colspan="3"><strong>Total</strong></td>
                                                                                <td><strong>{{ formatPrice(costSummary.packingTotal) }}</strong></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.packingTotal) }}</span>
                                            </div>
                                        </div>
                                        <!-- Sub Total: border top + bottom, bold (same as admin) -->
                                        <div class="col-md-12 byaddress-subtotal-block mb-1">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row byaddress-subtotal-row">
                                                <span class="total_p_custom byaddress-label">Sub Total</span>
                                                <span class="order_no byaddress-value">
                                                    {{ formatPrice(
                                                        costSummary.subTotal != null
                                                            ? Number(costSummary.subTotal)
                                                            : Number(costSummary.baseFeeTotal || 0) +
                                                              Number(costSummary.runChargeTotal || 0) +
                                                              Number(costSummary.setupDesignTotal || 0) +
                                                              Number(costSummary.packingTotal || 0)
                                                    ) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="costSummary.shippingTotal > 0">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row">
                                                <span class="total_p_custom byaddress-label">
                                                    <div class="d-flex align-items-center">
                                                        <span class="text-nowrap">{{ costSummary.shippingLabel }}</span>
                                                        <div class="tooltip-wrapper" v-if="costSummary.shippingBreakdown && costSummary.shippingBreakdown.length > 0" @click.stop="toggleOrderTooltip('shipping')">
                                                            <svg class="ml_6 info-icon-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                                            <div v-if="orderTooltipVisible === 'shipping'" class="tooltip-content is-visible">
                                                                <div class="tooltip-header">
                                                                    <h4>{{ costSummary.shippingLabel }} Breakdown</h4>
                                                                    <svg class="close-icon" @click.stop="closeOrderTooltip" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                    </svg>
                                                                </div>
                                                                <div class="tooltip-body">
                                                                    <table class="base-fee-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Fee</th>
                                                                                <th>Qty</th>
                                                                                <th>Amt</th>
                                                                                <th>Total</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in costSummary.shippingBreakdown" :key="index">
                                                                                <td>{{ item.name || item.service_name || 'Shipping and Freight Service' }}</td>
                                                                                <td>{{ (item.type === 'shipping_method' || item.name === 'Shipping Method Charge' || item.name === 'Shipping Charge') ? '-' : (item.quantity || item.qty || '-') }}</td>
                                                                                <td>{{ (item.type === 'shipping_method' || item.name === 'Shipping Method Charge' || item.name === 'Shipping Charge') ? '-' : (item.amt || item.amount ? formatPrice(parseFloat(item.amt || item.amount || 0)) : '-') }}</td>
                                                                                <td>{{ formatPrice(parseFloat(item.total || item.amt || item.amount || 0)) }}</td>
                                                                            </tr>
                                                                            <tr v-if="costSummary.shippingTotal > 0" class="total-row">
                                                                                <td colspan="3"><strong>Total</strong></td>
                                                                                <td><strong>{{ formatPrice(costSummary.shippingTotal) }}</strong></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.shippingTotal) }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="costSummary.salesTaxTotal > 0">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row">
                                                <span class="total_p_custom byaddress-label">
                                                    <div class="d-flex align-items-center">
                                                        <span class="text-nowrap">{{ costSummary.salesTaxLabel }}</span>
                                                        <div class="tooltip-wrapper" v-if="costSummary.salesTaxBreakdown && costSummary.salesTaxBreakdown.length > 0" @click.stop="toggleOrderTooltip('salesTax')">
                                                            <svg class="ml_6 info-icon-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                                            <div v-if="orderTooltipVisible === 'salesTax'" class="tooltip-content is-visible">
                                                                <div class="tooltip-header">
                                                                    <h4>{{ costSummary.salesTaxLabel }} Breakdown</h4>
                                                                    <svg class="close-icon" @click.stop="closeOrderTooltip" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                    </svg>
                                                                </div>
                                                                <div class="tooltip-body">
                                                                    <table class="base-fee-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Fee</th>
                                                                                <th>Qty</th>
                                                                                <th>Amt</th>
                                                                                <th>Total</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in costSummary.salesTaxBreakdown" :key="index">
                                                                                <td>{{ item.name || item.service_name || 'Sales Tax Service' }}</td>
                                                                                <td>{{ (item.type === 'sales_tax' || item.name === 'Sales Tax') ? '-' : (item.quantity || item.qty || '-') }}</td>
                                                                                <td>{{ (item.type === 'sales_tax' || item.name === 'Sales Tax') ? '-' : (item.amt || item.amount ? formatPrice(parseFloat(item.amt || item.amount || 0)) : '-') }}</td>
                                                                                <td>{{ formatPrice(parseFloat(item.total || item.amt || item.amount || 0)) }}</td>
                                                                            </tr>
                                                                            <tr v-if="costSummary.salesTaxTotal > 0" class="total-row">
                                                                                <td colspan="3"><strong>Total</strong></td>
                                                                                <td><strong>{{ formatPrice(costSummary.salesTaxTotal) }}</strong></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.salesTaxTotal) }}</span>
                                            </div>
                                        </div>
                                        <!-- Grand Total: border top, bold (matches admin byaddress-item-subtotal-block) -->
                                        <div class="col-md-12 byaddress-item-subtotal-block pt-1">
                                            <div class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row byaddress-item-subtotal-row">
                                                <span class="total_p_custom byaddress-label">Grand Total</span>
                                                <span class="order_no byaddress-value">{{ formatPrice(costSummary.grandTotal) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImprintLocationsRow from "./order-items-by-address/ImprintLocationsRow.vue";
import ArtworkPreviewModal from "./order-items-by-address/ArtworkPreviewModal.vue";
import NameNumberTable from "./order-items-by-address/NameNumberTable.vue";

export default {
    name: "OrderItemsByAddress",
    components: { ImprintLocationsRow, ArtworkPreviewModal, NameNumberTable },
    data() {
        return {
            openAddresses: {},
            orderTooltipVisible: null,
            selectedCanvasLocation: null,
            selectedCanvasModalKey: null
        };
    },
    props: {
        addresses: {
            type: Array,
            required: true
        },
        itemsByAddress: {
            type: Object,
            required: true
        },
        orderDetail: {
            type: Object,
            required: false,
            default: null
        },
        costSummary: {
            type: Object,
            required: false,
            default: null
        },
        formatPrice: {
            type: Function,
            required: false,
            default: (v) => (v != null ? String(v) : "")
        }
    },
    computed: {
        groupedByAddress() {
            const result = {};

            Object.keys(this.itemsByAddress || {}).forEach((addrId) => {
                const rows = this.itemsByAddress[addrId] || [];
                const byItem = {};

                const baseOrderItems =
                    (this.orderDetail && this.orderDetail.items) || [];

                rows.forEach((row) => {
                    if (!row || !row.item) return;
                    const item = row.item;
                    const colorId =
                        item.color && item.color.id != null ? item.color.id : "";
                    const key =
                        [item.id, colorId, item.unique_item_id]
                            .filter(Boolean)
                            .join("_") || `${item.product_number}_${row.sizeLabel}`;

                    if (!byItem[key]) {
                        let enrichedItem = item;
                        if (baseOrderItems && baseOrderItems.length > 0) {
                            const match = baseOrderItems.find(
                                (oi) =>
                                    (oi.id != null && oi.id === item.id) ||
                                    (oi.unique_item_id != null &&
                                        oi.unique_item_id === item.unique_item_id)
                            );
                            if (match && match.design_images) {
                                enrichedItem = Object.assign({}, item, {
                                    design_images: match.design_images
                                });
                            }
                        }
                        byItem[key] = {
                            item: enrichedItem,
                            sizes: [],
                            totalQty: 0,
                            estimatedShippingDate:
                                (row.split && row.split.estimated_shipping_date) ||
                                item.estimated_shipping_date ||
                                null
                        };
                    }

                    const qty =
                        row.split && typeof row.split.split_quantity === "number"
                            ? row.split.split_quantity
                            : parseInt(row.split && row.split.split_quantity, 10) ||
                              0;

                    byItem[key].sizes.push({
                        sizeLabel: row.sizeLabel,
                        qty
                    });
                    byItem[key].totalQty += qty;
                });

                result[addrId] = Object.values(byItem);
            });

            return result;
        }
    },
    methods: {
        isAddressOpen(address) {
            const id = address && address.id;
            if (!id) return true;
            if (this.openAddresses[id] === undefined) {
                return true;
            }
            return this.openAddresses[id];
        },
        toggleAddress(address) {
            const id = address && address.id;
            if (!id) return;
            const current = this.isAddressOpen(address);
            this.$set(this.openAddresses, id, !current);
        },
        toggleOrderTooltip(type) {
            this.orderTooltipVisible =
                this.orderTooltipVisible === type ? null : type;
        },
        closeOrderTooltip() {
            this.orderTooltipVisible = null;
        },
        getDecorationTypeAbbr(item) {
            if (!item) return "—";
            const name = (this.getDecorationServiceName(item) || "")
                .toLowerCase()
                .trim();
            if (name.indexOf("screen") >= 0 || name.indexOf("print") >= 0)
                return "SP";
            if (name.indexOf("embroid") >= 0) return "EMB";
            if (name.indexOf("deboss") >= 0) return "DEB";
            if (name.indexOf("heat") >= 0) return "HT";
            if (name.length >= 2) return name.substring(0, 3).toUpperCase();
            return name ? name.toUpperCase() : "—";
        },
        getImprintLocations(item) {
            if (!item) return [];
            const type = this.getDecorationTypeAbbr(item);
            let designImages = [];
            if (item.design_images) {
                try {
                    const parsed =
                        typeof item.design_images === "string"
                            ? JSON.parse(item.design_images)
                            : item.design_images;
                    designImages = Array.isArray(parsed) ? parsed : [];
                } catch (e) {}
            }
            const labelToCode = { front: "F", back: "B", left: "L", right: "R" };
            const order = ["front", "back", "left", "right"];
            const seen = new Set();
            const out = [];
            const fontNameJson = item ? this._getFontSizes(item, "name") : null;
            const fontNumberJson = item ? this._getFontSizes(item, "number") : null;

            designImages.forEach((di) => {
                const label =
                    (di && di.label && String(di.label).toLowerCase().trim()) || "";
                const loc =
                    order.find((o) => label === o || label.indexOf(o) === 0) ||
                    label ||
                    "front";
                const code = labelToCode[loc] || loc.charAt(0).toUpperCase();
                if (seen.has(code)) return;
                seen.add(code);
                let thumb = "";
                if (di && Array.isArray(di.canvas_images) && di.canvas_images.length) {
                    thumb = di.canvas_images[0].image_path || "";
                }
                if (!thumb && di) {
                    thumb = di.design_image || di.url || "";
                }
                let locColors = [];
                if (di && Array.isArray(di.colors) && di.colors.length) {
                    locColors = di.colors;
                } else if (
                    di &&
                    Array.isArray(di.canvas_images) &&
                    di.canvas_images.length &&
                    Array.isArray(di.canvas_images[0].colors) &&
                    di.canvas_images[0].colors.length
                ) {
                    locColors = di.canvas_images[0].colors;
                }

                if (!locColors.length) {
                    const locationKey =
                        code === "F"
                            ? "front"
                            : code === "B"
                            ? "back"
                            : code === "L"
                            ? "left"
                            : "right";
                    const nameColorHex =
                        fontNameJson &&
                        fontNameJson[locationKey] &&
                        fontNameJson[locationKey].nameFontColor;
                    const numberColorHex =
                        fontNumberJson &&
                        fontNumberJson[locationKey] &&
                        fontNumberJson[locationKey].numberFontColor;

                    const tmp = [];
                    const diLabel = di && di.label;
                    if (nameColorHex && this.hasNameForView(item, diLabel)) {
                        tmp.push({ name: "Name", hex: String(nameColorHex) });
                    }
                    if (numberColorHex && this.hasNumberForView(item, diLabel)) {
                        tmp.push({ name: "Number", hex: String(numberColorHex) });
                    }
                    if (tmp.length) locColors = tmp;
                }

                out.push({
                    code,
                    label: (di && di.label) || loc,
                    thumbnailUrl: thumb,
                    type,
                    colors: locColors
                });
            });
            const dec = this.getDecoration(item);
            if (out.length === 0 && (dec.art_work || item.front_art_url)) {
                out.push({
                    code: "F",
                    label: "Front",
                    thumbnailUrl: dec.art_work || item.front_art_url || "",
                    type,
                    colors: []
                });
            }
            return out;
        },
        getDecoration(item) {
            if (!item) return {};
            return item.NewOrderItemDecoration || item.NewOrderItemDecorations || {};
        },
        artworkImageUrl(item) {
            const dec = this.getDecoration(item);
            return (dec && dec.art_work) || (item && item.front_art_url);
        },
        getSplitNameNumberTable(addressId, group) {
            const addrId = addressId != null ? String(addressId) : null;
            if (!addrId || !this.itemsByAddress || !this.itemsByAddress[addrId]) {
                return [];
            }
            const rows = this.itemsByAddress[addrId] || [];
            const table = [];
            const sizeIdSet = new Set(
                ((group && group.item && group.item.sizes) || [])
                    .map((s) => (s && s.id != null ? String(s.id) : null))
                    .filter(Boolean)
            );
            rows.forEach((row) => {
                if (!row || !row.split) return;
                // Product-wise mapping should be based on the split's exact order_item_id
                const splitOrderItemId =
                    row.split && row.split.order_item_id != null
                        ? String(row.split.order_item_id)
                        : null;
                if (splitOrderItemId && sizeIdSet.size > 0) {
                    if (!sizeIdSet.has(splitOrderItemId)) return;
                } else {
                    // If we can't map by order_item_id, don't guess (prevents wrong product table)
                    return;
                }
                // Split-level name/number data (API guarantees this field)
                const rawSplitNameNumber =
                    row.split && row.split.name_and_number_json != null
                        ? row.split.name_and_number_json
                        : null;
                const nn = this.normalizeNameAndNumberJson(rawSplitNameNumber);
                if (nn && Array.isArray(nn) && nn.length > 0) {
                    nn.forEach((entry) => {
                        table.push({
                            name: entry.name || "",
                            number: entry.number || "",
                            size: row.sizeLabel || ""
                        });
                    });
                } else if (row.name || row.number) {
                    table.push({
                        name: row.name || "",
                        number: row.number || "",
                        size: row.sizeLabel || ""
                    });
                }
            });
            return table;
        },
        normalizeNameAndNumberJson(raw) {
            if (!raw) return [];
            let parsed =
                typeof raw === "string"
                    ? (() => {
                          try {
                              return JSON.parse(raw);
                          } catch (e) {
                              return null;
                          }
                      })()
                    : raw;
            if (!parsed) return [];
            if (Array.isArray(parsed)) {
                return parsed.filter(
                    (nn) =>
                        nn &&
                        (String(nn.name || "").trim() !== "" ||
                            String(nn.number || "").trim() !== "")
                );
            }
            if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
                const keys = ["front", "back", "left", "right"];
                let arr = [];
                const firstNonEmpty = keys.find(
                    (k) => Array.isArray(parsed[k]) && parsed[k].length > 0
                );
                if (firstNonEmpty) {
                    arr = parsed[firstNonEmpty];
                } else {
                    keys.forEach((k) => {
                        if (Array.isArray(parsed[k])) arr = arr.concat(parsed[k]);
                    });
                }
                return arr.filter(
                    (nn) =>
                        nn &&
                        (String(nn.name || "").trim() !== "" ||
                            String(nn.number || "").trim() !== "")
                );
            }
            return [];
        },
        showDesignImages(data) {
            if (data) {
                try {
                    let json = JSON.parse(data);
                    json = json.filter(
                        (img) => img.canvas_images && img.canvas_images.length > 0
                    );
                    if (json.length > 0) return true;
                } catch (e) {}
            }
            return false;
        },
        getDecorationServiceName(item) {
            if (!item || !item.decoration) return "";
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return "";
                }
            }
            if (decoration) {
                if (decoration.ecomm_display) return decoration.ecomm_display;
                if (
                    decoration.master_service &&
                    decoration.master_service.ecomm_display
                ) {
                    return decoration.master_service.ecomm_display;
                }
            }
            return "";
        },
        getDecoratorLogo(item) {
            if (!item) return "";
            const decorator = item.Decorator;
            if (decorator && decorator.logo_file) return decorator.logo_file;
            const vendor = item.Vendor;
            if (vendor && vendor.logo_file) return vendor.logo_file;
            return "";
        },
        getEstimatedShippingDate(item) {
            if (item && item.estimated_shipping_date) return item.estimated_shipping_date;
            if (item && item.sizes && Array.isArray(item.sizes) && item.sizes.length) {
                const parentSize = item.sizes.find((size) => size.parent === 1);
                if (parentSize && parentSize.estimated_shipping_date)
                    return parentSize.estimated_shipping_date;
                if (item.sizes[0] && item.sizes[0].estimated_shipping_date)
                    return item.sizes[0].estimated_shipping_date;
            }
            return null;
        },
        formatEstimatedShippingDate(dateString) {
            if (!dateString) return "";
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                const mm = String(date.getMonth() + 1).padStart(2, "0");
                const dd = String(date.getDate()).padStart(2, "0");
                const yyyy = date.getFullYear();
                return `${mm}/${dd}/${yyyy}`;
            } catch (e) {
                return dateString;
            }
        },
        parseDesignImages(designImages) {
            if (!designImages) return [];
            try {
                const parsed =
                    typeof designImages === "string"
                        ? JSON.parse(designImages)
                        : designImages;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },
        onImprintOpenCanvasModal(addrId, groupIdx, locationCode) {
            this.selectedCanvasLocation = locationCode || null;
            this.selectedCanvasModalKey = addrId + "-" + groupIdx;
            this.$nextTick(() => {
                const sel = "#canvas-images-model-byaddr-" + addrId + "-" + groupIdx;
                if (window.$ && typeof window.$.fn.modal === "function") {
                    window.$(sel).modal("show");
                }
            });
        },
        onCloseCanvasModalByAddress(addrId, groupIdx) {
            this.selectedCanvasLocation = null;
            this.selectedCanvasModalKey = null;
            const sel = "#canvas-images-model-byaddr-" + addrId + "-" + groupIdx;
            if (window.$ && typeof window.$.fn.modal === "function") {
                window.$(sel).modal("hide");
            }
        },
        getDesignImagesForCanvasModal(item, modalKey) {
            const raw = this.parseDesignImages(item.design_images);
            const withCanvas = (raw || []).map((di) => {
                if (
                    di &&
                    (!di.canvas_images || di.canvas_images.length === 0) &&
                    di.design_image
                ) {
                    return Object.assign({}, di, {
                        canvas_images: [
                            {
                                image_path: di.design_image,
                                image_name: di.label || "",
                                width_inch: null,
                                height_inch: null
                            }
                        ]
                    });
                }
                return di;
            });
            if (
                this.selectedCanvasModalKey !== modalKey ||
                !this.selectedCanvasLocation
            ) {
                return withCanvas;
            }
            return this.getDesignImagesFilteredByLocation(
                withCanvas,
                this.selectedCanvasLocation
            );
        },
        getDesignImagesFilteredByLocation(designImagesArray, locationCode) {
            if (!locationCode || !Array.isArray(designImagesArray))
                return designImagesArray || [];
            const codeToLabel = { F: "front", B: "back", L: "left", R: "right" };
            const label = codeToLabel[locationCode];
            if (!label) return designImagesArray;
            return designImagesArray.filter(
                (di) =>
                    di &&
                    di.label &&
                    String(di.label).toLowerCase().trim().indexOf(label) === 0
            );
        },
        parseDesignImagesForPreview(designImages) {
            if (!designImages) return [];
            try {
                const parsed =
                    typeof designImages === "string"
                        ? JSON.parse(designImages)
                        : designImages;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },
        existsNameAndNumber(data, type) {
            if (!data || !Array.isArray(data)) return false;
            return data.some(
                (nn) => nn && String(nn[type] || "").trim() !== ""
            );
        },
        normalizeLocationForNameNumber(location) {
            const s = (location || "").toString().toLowerCase().trim();
            const standard = ["front", "back", "left", "right"];
            const found = standard.find((k) => s === k || s.indexOf(k) === 0);
            return found || s;
        },
        getSelectedNameNumber(item) {
            if (!item || item.name_and_number_json == null) return {};
            let nn = item.name_and_number_json;
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn) || {};
                } catch (e) {
                    return {};
                }
            }
            return (nn && nn.selected_name_number) || {};
        },
        hasNameForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            if (locSel && locSel.name === false) return false;
            let nn = item.name_and_number_json;
            if (!nn && item.sizes && Array.isArray(item.sizes) && item.sizes.length > 0) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) {
                        nn = s.name_and_number_json;
                        break;
                    }
                }
            }
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn);
                } catch (e) {
                    nn = null;
                }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key =
                    Object.keys(nn).find((k) => this.normalizeLocationForNameNumber(k) === loc) ||
                    loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                return arr.some((e) => e && String(e.name || "").trim() !== "");
            }
            if (nn && Array.isArray(nn)) return this.existsNameAndNumber(nn, "name");
            return false;
        },
        hasNumberForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            if (locSel && locSel.number === false) return false;
            let nn = item.name_and_number_json;
            if (!nn && item.sizes && Array.isArray(item.sizes) && item.sizes.length > 0) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) {
                        nn = s.name_and_number_json;
                        break;
                    }
                }
            }
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn);
                } catch (e) {
                    nn = null;
                }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key =
                    Object.keys(nn).find((k) => this.normalizeLocationForNameNumber(k) === loc) ||
                    loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                return arr.some(
                    (e) =>
                        e &&
                        e.number != null &&
                        (e.number === 0 ||
                            e.number === "0" ||
                            String(e.number).trim() !== "")
                );
            }
            if (nn && Array.isArray(nn)) return this.existsNameAndNumber(nn, "number");
            return false;
        },
        _getFontSizes(item, which) {
            const raw =
                which === "name"
                    ? item.font_color_sizes_name
                    : item.font_color_sizes_number;
            if (!raw) return null;
            return typeof raw === "string"
                ? (() => {
                      try {
                          return JSON.parse(raw);
                      } catch (e) {
                          return null;
                      }
                  })()
                : raw;
        }
    }
};
</script>

<style scoped>
.address-header {
    background-color: #f5f5f5;
    border: 1px solid #dedede;
    padding: 12px 16px;
    font-size: 14px;
    color: #414141;
    font-weight: 500;
    line-height: 16px;
    cursor: pointer;
    margin-top: 16px;
}

.address-header-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.address-header-arrow {
    margin-left: 8px;
}

.arrow-icon {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #999;
    border-bottom: 2px solid #999;
    transform: rotate(45deg);
    transition: transform 0.15s ease;
}

.arrow-icon.open {
    transform: rotate(-135deg);
}

/* Row separation (match admin: full border on each item card) */
.base_pro_row_custom {
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #BEBEBE66;
}

.order-list-col,
.order-list-col-sec {
    align-self: stretch;
}

.imprint-locations-wrapper {
    margin-top: 0;
}

.brand-logo-wrapper {
    min-width: 120px;
}

.brand-logo-img {
    max-width: 120px;
    max-height: 50px;
    object-fit: contain;
    display: inline-block;
}

.decoration-service-name {
    font-size: 13px;
    color: #555;
    font-weight: 500;
}

.decoration-shipdate {
    font-size: 13px;
    color: #666;
    margin-top: 4px;
}

.name-number-data {
    border-collapse: collapse;
    border: 1px solid #d7c6c6;
    font-size: 12px;
    width: 100%;
    max-width: 260px;
}

.name-number-data .data-heading {
    background-color: #f5f5f5;
    font-weight: 600;
    padding: 4px 8px;
    border-right: 1px solid #d7c6c6;
}

.name-number-data .cart-data-col td {
    padding: 4px 8px;
    border-top: 1px solid #d7c6c6;
    border-right: 1px solid #d7c6c6;
}

.acc__panel.order-list-page {
    overflow: visible !important;
}

.order-list-page .table-btn-col {
    justify-content: center !important;
}

.mt_8 {
    margin-top: 8px;
}

.color_swatch_byaddr {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    display: inline-block;
    border: 1px solid #ddd;
    border-radius: 2px;
    vertical-align: middle;
    object-fit: cover;
}

.byaddress-total-section.total_price {
    margin-top: 1rem;
}

.byaddress-fee-summary {
    border: 0 !important;
    border-radius: 0;
    padding: 8px 0 4px;
    background: transparent;
    font-family: "Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.byaddress-total-row {
    flex-wrap: nowrap;
    align-items: center;
    padding: 8px 0;
    min-height: 22px;
}

.byaddress-total-row .total_p_custom {
    min-width: 0;
    flex: 1 1 auto;
}

.byaddress-label {
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    margin-right: 8px;
    position: relative;
}

/* Regular line item rows */
.byaddress-fee-summary .byaddress-total-row:not(.byaddress-subtotal-row):not(.byaddress-item-subtotal-row) .byaddress-label {
    color: #606060;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400 !important;
}

.byaddress-value {
    flex-shrink: 0;
    font-weight: 400;
    text-align: right;
}

.byaddress-fee-summary .byaddress-total-row:not(.byaddress-subtotal-row):not(.byaddress-item-subtotal-row) .byaddress-value {
    color: #121212;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400 !important;
    text-align: right;
}

/* Sub Total: border top + bottom, bold */
.byaddress-subtotal-block {
    margin-top: 0;
    padding: 10px 0;
    border-top: 1px solid #BEBEBE4D;
    border-bottom: 1px solid #BEBEBE4D;
}

.byaddress-subtotal-row .byaddress-label,
.byaddress-subtotal-row .byaddress-value {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 1.35;
}

/* Item Sub Total: border top, bold */
.byaddress-item-subtotal-block {
    margin-top: 0;
    padding-top: 10px;
    border-top: 1px solid #BEBEBE4D;
}

.byaddress-item-subtotal-row .byaddress-label,
.byaddress-item-subtotal-row .byaddress-value {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 1.35;
}

.byaddress-grand-total .byaddress-value {
    font-weight: 700;
}

/* col-md-12 spacing inside fee summary */
.byaddress-fee-summary .col-md-12 {
    padding: 0px 0px 12px 0px;
}

.byaddress-fee-summary .col-md-12.byaddress-subtotal-block {
    padding: 12px 0px 12px 0px;
}

.artwork-old-block {
    display: none;
}

/* Tooltip in cost summary: open leftward so it doesn't overflow right edge */
.byaddress-fee-summary .tooltip-content {
    left: auto !important;
    right: 0 !important;
    transform: none !important;
}

/* ===== Items by Address: product item row — matches admin structure ===== */

/* product_details_box: space-between keeps product info left, decorator logo right */
.product_details_box {
    padding-bottom: 12px;
    justify-content: space-between;
}

/* product image box */
.order-list-col .product-box {
    width: 90px !important;
    height: 90px !important;
    min-width: 90px !important;
    min-height: 90px !important;
    max-width: 90px !important;
    max-height: 90px !important;
    padding: 0 !important;
    border: 1px solid #d3d3d3 !important;
    background-color: #f8f8f8 !important;
    margin-right: 16px !important;
    flex-shrink: 0 !important;
    position: relative;
    overflow: hidden;
}

.order-list-col .product-box img.img-fluid {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    display: block !important;
}

/* product number badge below image */
.product_number {
    border: 1px solid #D3D3D3;
    background-color: #F4F4F4;
    max-width: 90px;
    display: block;
    text-align: center;
    font-size: 12px;
    padding: 1px 4px;
}

/* Name/Number table export button: below the table (column-reverse) */
.order-list-page .order-list-col .table-btn-col {
    flex-direction: column-reverse !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    margin-bottom: 20px;
}

.order-list-page .order-list-col .data-export-btn .export-btn {
    margin-top: 20px;
    padding: 8px;
    font-size: 14px;
}
</style>

